<template lang="pug">
  layout-form(v-if="profile.id" :value="profile" form='user')
</template>

<script>
import User from '@/models/User';
import { mapGetters } from 'vuex';

export default {
  name: 'view-profile',

  data: () => ({
    profile: new User(),
  }),

  computed: {
    ...mapGetters(['user']),
  },

  created() {
    this.profile.$assign(this.user.$getData());
  },
};
</script>
